<p>Dia {{ infoDia }} - {{ data | date : 'dd/MM/yyyy'}}</p>
